// A1-103 step 4 (operator 2026-10-30, duplicates: "it should not happen") —
// "Leave out the copy" on the duplicates card. Offered by the server only on a
// row whose exact twin stays in this calculation (engine/duplicate_copies), so
// the sale is still counted once. Saved at once and applied by the next
// re-run, like every Step 4 answer (SavedAnswersBar); "Keep both" withdraws it
// until then.
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { authClient } from "../../lib/authApi";
import { errorMessage } from "../../lib/errorMessage";
import { toast } from "../ui/sonner";

export const LEAVE_OUT_REASON = "Left out: an exact copy of another row in the same upload.";

// `allOpen`: every open copy on the card, all pages — the server works out
// which (the screen holds only the page it shows).
export const LeaveOutCopy = ({ tids, allOpen, calcId, calcFrozen, onResolved, label, testId }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  if (calcFrozen || (!allOpen && !tids?.length)) return null;

  const submit = async () => {
    if (busy) return;
    setBusy(true); setErr(null);
    try {
      await authClient.post(`/runs/calc/${calcId}/leave-out-copies`, {
        ...(allOpen ? { all_open: true } : { txn_ids: tids }),
        reason: t("ui.review_answers.leave_out_reason", { defaultValue: LEAVE_OUT_REASON }),
      });
      toast.success(t("ui.review_answers.leave_out_saved", {
        defaultValue: "Left out — applied when the calculation re-runs" }));
      if (onResolved) await onResolved();
    } catch (e) {
      setErr(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="inline-flex flex-col gap-0.5">
      <button type="button" data-testid={testId || `leave-out-${tids?.[0]}`} onClick={submit} disabled={busy}
              aria-busy={busy}
              className="text-xs px-2 py-1 rounded-md border border-slate-400 dark:border-slate-500 text-slate-900 dark:text-slate-100 hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-60">
        {busy ? t("ui.review_answers.leave_out_busy", { defaultValue: "Saving…" })
          : label || t("ui.review_answers.leave_out_one", { defaultValue: "Leave out this copy" })}
      </button>
      {err && <span role="alert" className="text-xs text-red-700 dark:text-red-300">{err}</span>}
    </span>
  );
};

export default LeaveOutCopy;
